'use client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type { PhoneInputProps, CountryData } from 'react-international-phone';
import { PhoneInput, defaultCountries } from 'react-international-phone';
import './phone-input-styles.css';

export const PhoneInputField = forwardRef<
  HTMLInputElement,
  PhoneInputProps & { variant?: 'outlined' | 'default' }
>(function PhoneInputField({ className, variant, ...props }, ref) {
  const [focused, setFocused] = useState(false);
  const phoneInputRef = useRef(ref ?? null);

  const customCountries = defaultCountries.map(country => {
    if (country[1] === 'sk') {
      return ['Slovakia', 'sk', '421', '... ... ...'] as CountryData;
    }
    return country;
  });

  const locale = useLocaleStore(s => s.currentLocale);

  const defaultCountryFromLocale = () => {
    if (locale === 'cs') {
      return 'cz';
    }

    return locale;
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const current = phoneInputRef.current as any;

      if (current && !current.contains(event.target)) {
        setFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [phoneInputRef]);

  return (
    <div
      ref={phoneInputRef as any}
      className={cn(
        'flex h-[52px] w-full items-center rounded-[20px] border border-border',
        className,
      )}
    >
      <PhoneInput
        defaultCountry={defaultCountryFromLocale()}
        name="phone"
        countries={customCountries}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        inputClassName={props.inputClassName}
        inputStyle={{
          height: '40px',
          paddingLeft: '12px',
          width: '100%',
          border: 'none',
          borderRadius: 0,
          backgroundColor: 'transparent',
          outline: 'none',
        }}
        countrySelectorStyleProps={{
          buttonClassName: '',
          buttonStyle: {
            height: '36px',
            border: 'none',
            borderRadius: '20px',
            backgroundColor: '#F3F4F6',
            margin: '6px',
            paddingLeft: '24px',
            paddingRight: '24px',
            gap: '6px',
          },
        }}
        {...props}
      />
    </div>
  );
});

PhoneInputField.displayName = 'PhoneInputField';
